import { Component, input } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, DomLayoutType } from 'ag-grid-community';
import { treatiesDefaultColDef, TREATY_PAGE_SIZE } from '../treaty-table.config';
import { customTheme } from 'src/styles/grid-table/grid-table-theme';

@Component({
  selector: 'app-treaty-table',
  imports: [AgGridAngular],
  template: `
    <ag-grid-angular
      style="width: 100%; height: 100%"
      [columnDefs]="colDefs()"
      [pagination]="pagination()"
      [paginationPageSize]="pageSize"
      [paginationPageSizeSelector]="false"
      [defaultColDef]="defaultColDef()"
      [theme]="theme"
      [rowData]="rowData()"
      [domLayout]="domLayout()"
    />
  `,
})
export class TreatyTableComponent<T> {
  colDefs = input.required<ColDef[]>();
  defaultColDef = input<ColDef>(treatiesDefaultColDef);
  rowData = input.required<T[]>();
  pagination = input<boolean>(false);
  domLayout = input<DomLayoutType>('normal');

  pageSize = TREATY_PAGE_SIZE;
  theme = customTheme.withParams({ autoHeightMinBodyHeight: '42px' });
}
